var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-row align-items-end" }, [
    _vm.schoolStatus && !_vm.onlyAcademic
      ? _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.all_schools"),
                options: _vm.SchoolsForSelect,
                name: "school",
                model: _vm.localFilters,
                "label-field": "name",
                "value-field": "id",
                reduce: (value) => value.id,
                multiple: _vm.isSuperadminLoggedSchool,
                selectAllOption: false,
              },
              on: {
                change: function ($event) {
                  return _vm.loadAllDataToSelects()
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.academicYearStatus
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.academic_year"),
                options: _vm.academicYears,
                name: "academicYear",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
              },
              on: { change: _vm.changeMarkingPeriod },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showAnotherAcademicYear
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.another_academic_year"),
                reduce: (value) => value.id,
                options: _vm.academicYears,
                name: "doesnotHaveAcademicYearEnrollment",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.stageStatus && !_vm.onlyAcademic
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.stage"),
                options: _vm.stagesForSelect,
                name: "stageEnrollment",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name_with_school",
                "value-field": "id",
                reduce: (value) => value.id,
                selectAllOption: false,
                multiple: "",
              },
              on: {
                change: function ($event) {
                  return _vm.getYearLevels()
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.yearLevelStatus && !_vm.onlyAcademic
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.yearLevel"),
                options: _vm.yearLevelForSelect,
                name: "yearLevelEnrollment",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                "value-field": "id",
                reduce: (value) => value.id,
                selectAllOption: false,
                multiple: "",
              },
              on: {
                change: function ($event) {
                  return _vm.getClasses()
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.onlyAcademic
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.classes"),
                options: _vm.classes,
                name: "classEnrollment",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                "value-field": "id",
                reduce: (value) => value.id,
                selectAllOption: false,
                multiple: "",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.onlyAcademic && _vm.showBox
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.name_box"),
                options: _vm.usersForSelect,
                name: "user",
                model: _vm.localFilters,
                "label-field": "name",
                reduce: (value) => value.id,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.onlyAcademic && _vm.showfeeCategory
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.feeCategory"),
                options: _vm.InvoiceCategoryForSelect,
                name: "category",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name_with_school",
                selectAllOption: false,
                multiple: "",
                reduce: (value) => value.id,
              },
              on: { change: _vm.getFeeTypes },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.onlyAcademic && _vm.parent_code
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-input", {
              attrs: {
                label: _vm.Lang.get("messages.parent_code_name"),
                name: "parentNameOrCode",
                model: _vm.localFilters,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.onlyAcademic && _vm.student_code
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-input", {
              attrs: {
                label: _vm.Lang.get("messages.student_code_name"),
                name: "nameOrCode",
                model: _vm.localFilters,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.marking_period && !_vm.onlyAcademic
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.marking_period"),
                options: _vm.markingPeriodsForSelect,
                name: "marking_period_id",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name_with_school",
                reduce: (value) => value.id,
                multiple: true,
              },
              on: { change: _vm.markingPeriodChange },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.from_date && !_vm.onlyAcademic
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-date", {
              attrs: {
                label: _vm.Lang.get("messages.from_date"),
                name: "billingFromDate",
                options: _vm.dateOptions,
                model: _vm.localFilters,
                errors: _vm.formErrors,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.to_date && !_vm.onlyAcademic
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-date", {
              attrs: {
                label: _vm.Lang.get("messages.to_date"),
                name: "billingToDate",
                options: _vm.dateOptions,
                model: _vm.localFilters,
                errors: _vm.formErrors,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.from && !_vm.onlyAcademic
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-input", {
              attrs: {
                label: _vm.Lang.get("messages." + _vm.balance_from),
                name: "from",
                model: _vm.localFilters,
                type: "number",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.to && !_vm.onlyAcademic
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-input", {
              attrs: {
                label: _vm.Lang.get("messages." + _vm.balance_to),
                name: "to",
                model: _vm.localFilters,
                type: "number",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.from && !_vm.onlyAcademic
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-input", {
              attrs: {
                label:
                  _vm.Lang.get("messages.paid amount") +
                  " - " +
                  _vm.Lang.get("messages.from"),
                name: "paidFrom",
                model: _vm.localFilters,
                type: "number",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.to && !_vm.onlyAcademic
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-input", {
              attrs: {
                label:
                  _vm.Lang.get("messages.paid amount") +
                  " - " +
                  _vm.Lang.get("messages.to"),
                name: "paidTo",
                model: _vm.localFilters,
                type: "number",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.fromNumber && !_vm.onlyAcademic
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-input", {
              attrs: {
                label: _vm.Lang.get("messages.from_number"),
                name: "fromNumber",
                type: "number",
                model: _vm.localFilters,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.toNumber && !_vm.onlyAcademic
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-input", {
              attrs: {
                label: _vm.Lang.get("messages.to_number"),
                name: "toNumber",
                type: "number",
                model: _vm.localFilters,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.onlyAcademic && _vm.nationality && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.nationality"),
                options: _vm.nationalitiesForSelect,
                name: "nationalityKeyword",
                model: _vm.localFilters,
                "label-field": "name_with_school",
                reduce: (value) => value.name_en,
                disabled: _vm.unspecifiedNationalityStatus,
                selectAllOption: false,
                multiple: "",
              },
              on: {
                change: function ($event) {
                  return _vm.clearInput("nationalityKeyword")
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.onlyAcademic && _vm.studentStatus && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.student_status"),
                options: _vm.studentStatusForSelect,
                name: "studentStatus",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                reduce: (value) => value.id,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.registerStatus && !_vm.onlyAcademic && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.registration_status"),
                options: _vm.registrationStatusForSelect,
                name: "registrationType",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                reduce: (val) => val.id,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.studyStatus && !_vm.onlyAcademic && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.study_status"),
                options: _vm.studyStatusForSelect,
                name: "studyStatus",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                reduce: (val) => val.id,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.onlyAcademic && _vm.medicalAvailability && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.medical_availability"),
                options: _vm.booleanForSelect,
                name: "medicalAvailability",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                reduce: (value) => value.id,
              },
              on: {
                change: function ($event) {
                  return _vm.clearInput("medicalAvailability")
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.onlyAcademic && _vm.religion && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.religion"),
                options: _vm.religionsForSelect,
                name: "religion",
                model: _vm.localFilters,
                "label-field": "name_with_school",
                reduce: (value) => value.id,
              },
              on: {
                change: function ($event) {
                  return _vm.clearInput("religion")
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.onlyAcademic && _vm.gender && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.gender"),
                options: _vm.genderForSelect,
                name: "gender",
                model: _vm.localFilters,
                "label-field": "name",
                reduce: (value) => value.id,
              },
              on: {
                change: function ($event) {
                  return _vm.clearInput("gender")
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.onlyAcademic && _vm.isStaff && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.working_sons"),
                options: _vm.booleanForSelect,
                name: "isStaff",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                reduce: (value) => value.id,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.onlyAcademic && _vm.atExpenseOf && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label:
                  _vm.Lang.get("messages.expenses_of") +
                  " (" +
                  _vm.Lang.get("messages.financial") +
                  ")",
                reduce: (value) => value.id,
                options: _vm.expensesTypesforSelect,
                name: "atExpenseOf",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.discount_type && !_vm.onlyAcademic && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.discountType"),
                options: _vm.discountTypesForSelect,
                reduce: (value) => value.id,
                name: "modelDiscountType",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
              },
              on: {
                change: function ($event) {
                  return _vm.getCategoryTypes()
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.discount && !_vm.onlyAcademic && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.discount"),
                options: _vm.discountTypeForSelect,
                name: "modelDiscount",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name_with_school",
                reduce: (value) => value.id,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.payment && !_vm.onlyAcademic && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.payment_type"),
                options: _vm.paymentTypesForSelect,
                name: "paymentType",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                reduce: (value) => value.id,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.organization &&
    _vm.$mods.billing.funding_organization &&
    !_vm.onlyAcademic &&
    !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.organization"),
                reduce: (value) => value.id,
                options: _vm.organizationsForSelect,
                name: "organization",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                multiple: "",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.registration_type && !_vm.onlyAcademic && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.registrationType"),
                options: _vm.registrationStatusForSelect,
                name: "registrationType",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                reduce: (value) => value.id,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.registration_type && !_vm.onlyAcademic && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.external_school"),
                options: _vm.prevSchoolsForSelect,
                name: "previousSchool",
                model: _vm.localFilters,
                reduce: (value) => value.id,
                errors: _vm.formErrors,
                "label-field": "name_with_school",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.sanad_type && !_vm.onlyAcademic && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.sand_type"),
                options: _vm.sandTypesForSelect,
                name: "action",
                model: _vm.localFilters,
                "label-field": "name",
                reduce: (value) => value.id,
                selectAllOption: false,
                multiple: "",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.expenseAt && !_vm.onlyAcademic && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label:
                  _vm.Lang.get("messages.expense_at") +
                  " (" +
                  _vm.Lang.get("messages.registration") +
                  ")",
                options: _vm.expenseTypesForSelect,
                name: "expenseAt",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                reduce: (value) => value.id,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.paymentMethod && !_vm.onlyAcademic && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.method"),
                options: _vm.paymentMethodsForSelect,
                name: "paymentMethod",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                reduce: (value) => value.id,
                selectAllOption: false,
                multiple: "",
              },
              on: {
                change: function ($event) {
                  return _vm.clearInput("paymentMethod")
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clientTypeFilter && !_vm.knet
      ? _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-4" },
          [
            _c("form-select", {
              attrs: {
                label: _vm.Lang.get("messages.type"),
                options: _vm.clientTypesOptions,
                name: "clientType",
                model: _vm.localFilters,
                errors: _vm.formErrors,
                "label-field": "name",
                reduce: (value) => value.id,
              },
              on: {
                change: function ($event) {
                  return _vm.clearInput("clientTypes")
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }